import { connect } from 'react-redux';

import { selectUserInfo } from 'selectors/general';

import ClassesList from './ClassesList';

const mapStateToProps = state => {
  const { locale } = selectUserInfo(state);

  return {
    locale,
  };
};

export default connect(mapStateToProps)(ClassesList);
